export const makeAnchorId = (sectionId: string) =>
  `section-${sectionId.replace(/[^\w-]+/g, '-')}`;
